import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { actions as notificationActions } from '../../store/notificationsManager'
import TrainingReport from './component'
import {
  operations as sitesOperations,
  selectors as sitesSelectors,
} from 'store/sitesManager'
import { operations as lmsOperations } from 'store/lmsManager'

export const TrainingReportContainer = props => {
  const {
    data,
    error,
    fetchSiteUsers,
    fetchTrainingCompletion,
    isLoading,
    location,
    pushTo,
    site,
    siteId,
    siteUsers,
    sites,
  } = props

  useEffect(() => {
    if (!siteUsers) {
      fetchSiteUsers(siteId)
      fetchTrainingCompletion(siteId)
    }
  }, [siteId, pushTo])

  const pendingUsersCount = siteUsers?.filter(
    user => user?.status === 'Invited',
  ).length
  const activeUsers = siteUsers?.filter(user => user?.status === 'Active')

  const redirectToUserManagement = () => {
    pushTo(`/user-management/${siteId}`)
  }

  const onSiteChange = e => {
    const { value } = e
    const newSiteId = value.id || {}
    const isDifferentSite = siteId !== newSiteId

    if (isDifferentSite) {
      pushTo(`/training-report/${newSiteId}`)
    }
  }

  let k8Sites = sites?.filter(site =>
    site?.licenses?.some(license => {
      const programCodes = license?.product?.programCodes || []
      const hasK8Program = programCodes.some(code =>
        ['K8P', 'K12P', 'MSP'].includes(code),
      )
      return hasK8Program && license.isActive && license?.status !== 'Expired'
    }),
  )

  return (
    <TrainingReport
      data={data}
      error={error}
      isLoading={isLoading}
      location={location}
      onSiteChange={onSiteChange}
      pendingUsersCount={pendingUsersCount}
      redirectToUserManagement={redirectToUserManagement}
      site={site}
      siteId={siteId}
      siteUsers={activeUsers}
      sites={k8Sites}
    />
  )
}

TrainingReportContainer.propTypes = {
  addNotification: PropTypes.func.isRequired,
  data: PropTypes.array,
  error: PropTypes.object,
  fetchSiteUsers: PropTypes.func.isRequired,
  fetchTrainingCompletion: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    query: PropTypes.object,
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      siteId: PropTypes.string,
    }),
  }),
  message: PropTypes.string,
  pushTo: PropTypes.func.isRequired,
  site: PropTypes.object,
  siteId: PropTypes.number,
  siteUsers: PropTypes.array,
  sites: PropTypes.array,
}

TrainingReportContainer.defaultProps = {
  isLoading: false,
  data: [],
  error: null,
  message: '',
}

const mapStateToProps = (state, { match }) => {
  const {
    router,
    sitesManager: {
      message,
      sites: { data: sites, isLoading: isSitesLoading },
      siteUsers: { isLoading: isSiteUsersLoading },
    },
    lmsManager: { isFetching: isTrainingCompletionLoading },
  } = state

  const isLoading =
    isSitesLoading || isSiteUsersLoading || isTrainingCompletionLoading
  let { siteId } = match.params
  siteId = parseInt(siteId, 10)
  const site = !siteId ? sites[0] : sites.find(site => site.id === siteId)

  const siteUsers = sitesSelectors.selectSiteUsersWithTrainingCompletionBySiteId(
    state,
    siteId,
  )

  const { location } = router

  return {
    isLoading,
    location,
    message,
    site,
    siteId,
    sites,
    siteUsers,
  }
}

const mapDispatchToProps = {
  addNotification: notificationActions.addNotification,
  fetchSiteUsers: sitesOperations.fetchSiteUsers,
  fetchTrainingCompletion: lmsOperations.fetchTrainingCompletion,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TrainingReportContainer)
